export default __webpack_public_path__ + "static/media/consorcioLogo.b8676592.svg";